<template>
<v-app>
<v-sheet
    height="100%"
    class="overflow-hidden"
    style="position: relative;"
  >
  <v-overlay :value="overlay">
    <v-progress-circular indeterminate size="64" color="accent"></v-progress-circular>
  </v-overlay>
  <v-card class="mx-auto overflow-hidden" height="100%">
    <v-app-bar app
      dark
        :color="appBarColor"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>
      <svg width="130" height="20" viewBox="0 0 696 133" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
        <title>Teradata</title>
        <desc>Copyright Teradata</desc>
        <defs></defs>
        <g id="teradata" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="text" fill="#FFFFFE">
                <path d="M78.882,72.796 L123.941,72.796 C120.763,60.83 111.788,55.595 101.878,55.595 C92.53,55.595 81.873,61.204 78.882,72.796 Z M149.182,90.184 L78.134,90.184 C80.564,103.646 90.099,111.873 101.504,111.873 C108.796,111.873 117.957,110.937 124.689,99.533 L146.751,104.206 C138.524,123.652 121.884,133 101.504,133 C75.142,133 53.64,112.994 53.64,83.64 C53.64,54.286 75.142,34.093 101.878,34.093 C126.745,34.093 148.246,53.351 149.182,81.771 L149.182,90.184 Z" id="Fill-1"></path>
                <path d="M387.843,83.64 C387.843,66.439 374.568,55.595 361.294,55.595 C346.336,55.595 335.118,66.439 335.118,83.64 C335.118,100.841 346.336,111.498 361.294,111.498 C374.568,111.498 387.843,100.841 387.843,83.64 Z M412.523,130.195 L387.843,130.195 L387.843,122.156 C380.364,129.074 370.081,133 356.993,133 C333.248,133 311.186,112.994 311.186,83.64 C311.186,54.286 333.248,34.093 356.993,34.093 C370.081,34.093 380.364,38.019 387.843,44.937 L387.843,0.937 L412.523,0.937 L412.523,130.195 Z" id="Fill-3"></path>
                <path d="M630.3,92.427 C630.3,104.393 618.894,113.368 605.807,113.368 C596.271,113.368 589.915,108.88 589.915,101.962 C589.915,95.606 595.149,91.306 603.003,91.306 L630.3,91.306 L630.3,92.427 Z M614.407,37.117 L614.407,37.093 L580.299,37.093 L580.299,57.658 L614.407,57.658 C623.943,57.658 630.3,61.765 630.3,71.113 L630.3,72.61 L603.377,72.61 C579.818,72.61 566.356,84.576 566.356,102.524 C566.356,120.846 580.566,133 601.881,133 C614.595,133 623.943,128.7 630.3,122.53 L630.3,130.195 L653.858,130.195 L653.858,69.244 C653.858,47.082 638.243,37.617 614.407,37.117 Z" id="Fill-4"></path>
                <path d="M484.378,92.427 C484.378,104.393 472.973,113.368 459.885,113.368 C450.349,113.368 443.992,108.88 443.992,101.962 C443.992,95.606 449.227,91.306 457.08,91.306 L484.378,91.306 L484.378,92.427 Z M468.485,37.117 L468.485,37.093 L434.377,37.093 L434.377,57.658 L468.485,57.658 C478.02,57.658 484.378,61.765 484.378,71.113 L484.378,72.61 L457.454,72.61 C433.895,72.61 420.434,84.576 420.434,102.524 C420.434,120.846 434.644,133 455.958,133 C468.672,133 478.02,128.7 484.378,122.53 L484.378,130.195 L507.935,130.195 L507.935,69.244 C507.935,47.082 492.321,37.617 468.485,37.117 Z" id="Fill-5"></path>
                <path d="M279.3,92.427 C279.3,104.393 267.894,113.368 254.807,113.368 C245.271,113.368 238.914,108.88 238.914,101.962 C238.914,95.606 244.15,91.306 252.003,91.306 L279.3,91.306 L279.3,92.427 Z M263.408,37.117 L263.408,37.093 L229.299,37.093 L229.299,57.658 L263.408,57.658 C272.943,57.658 279.3,61.765 279.3,71.113 L279.3,72.61 L252.376,72.61 C228.818,72.61 215.356,84.576 215.356,102.524 C215.356,120.846 229.566,133 250.881,133 C263.595,133 272.943,128.7 279.3,122.53 L279.3,130.195 L302.858,130.195 L302.858,69.244 C302.858,47.082 287.244,37.617 263.408,37.117 Z" id="Fill-6"></path>
                <path d="M216.11,37.026 C200.966,37.026 190.121,43.069 182.643,53.913 L182.643,36.899 L157.963,36.899 L157.963,130.197 L182.643,130.197 L182.643,100.095 C182.643,74.106 193.113,57.776 215.923,57.776 L217.044,57.776 L217.044,37.029 C216.741,37.027 216.431,37.026 216.11,37.026" id="Fill-7"></path>
                <path d="M48.982,107.707 C45.229,109.115 41.291,110.002 38.328,110.002 C30.102,110.002 24.68,105.142 24.68,93.923 L24.68,57.09 L49.982,57.09 L49.982,36.898 L24.68,36.898 L24.68,14.007 L0,14.007 L0,95.793 C0,121.408 14.584,133 36.646,133 C44.438,133 51.879,131.338 61.481,126.199 C56.364,121.123 51.667,114.8 48.982,107.707" id="Fill-8"></path>
                <path d="M558.509,109.788 C557.521,109.926 556.586,110.002 555.733,110.002 C547.507,110.002 542.085,105.142 542.085,93.923 L542.085,57.09 L568.068,57.09 L568.068,36.898 L542.085,36.898 L542.085,14.007 L517.404,14.007 L517.404,95.793 C517.404,121.408 531.988,133 554.051,133 C559.44,133 564.302,132.206 569.964,130.017 C562.645,124.774 559.799,116.281 558.509,109.788" id="Fill-9"></path>
            </g>
            <path d="M695.029,116.028 C695.029,124.853 688.257,131.624 678.817,131.624 C669.377,131.624 662.605,124.853 662.605,116.028 C662.605,107.615 669.377,100.227 678.817,100.227 C688.257,100.227 695.029,107.615 695.029,116.028" id="Fill-11" fill="#E46C42"></path>
        </g>
</svg>  <span _ngcontent-nnp-c139="" class="ng-star-inserted">{{toolbar.title}}</span></v-toolbar-title>
      <div class="flex-grow-1"></div>

      <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-badge
            :content="totalNoLeidas"
            color="red"
            overlap
            v-if="totalNoLeidas > 0"
          >
            <v-icon>mdi-comment-alert</v-icon>
          </v-badge>
          <v-icon v-else>mdi-comment-alert</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="n in notificaciones2"
          :key="n.RepOrderNotification_id"
          @click="marcarComoLeida(n.RepOrderNotification_id)"
          :class="{ 'green lighten-4': n.RepOrderNotification_Ind == 'N     ' }"
        >
          <v-list-item-content>
            <v-list-item-title class="d-flex align-center">
              <v-icon
                v-if="n.RepOrderNotification_Ind === 'N     '"
                color="green"
                small
                class="mr-2"
              >
                mdi-circle
              </v-icon>
              {{ n.RepOrderNotification_Title }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ n.RepOrderNotification_Desc }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

      <v-btn icon @click="notificationDrawer = true">
        <v-badge
          :content="unreadNotificationsCount"
          :value="unreadNotificationsCount > 0"
          color="red"
          overlap>
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>

      <v-btn icon v-if="logged === false" v-on:click="dialog = true">
        <v-icon>mdi-login</v-icon>
      </v-btn>

      <v-btn icon v-if="logged === true" v-on:click="logout">
        <v-icon>mdi-exit-run</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>

      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
    <v-overlay :value="overlay"></v-overlay>
      <!-- -->
      <v-list-item style="background: #e0e0e0;">
        <v-list-item-content>
          <v-list-item-title class="title">
            <svg width="40%" height="100%" viewBox="0 0 696 133" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
              <title>Teradata</title>
              <desc>Copyright Teradata</desc>
              <defs></defs>
              <g id="teradata-2-color" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="text" fill="#354145">
                      <path d="M78.882,72.796 L123.941,72.796 C120.763,60.83 111.788,55.595 101.878,55.595 C92.53,55.595 81.873,61.204 78.882,72.796 Z M149.182,90.184 L78.134,90.184 C80.564,103.646 90.099,111.873 101.504,111.873 C108.796,111.873 117.957,110.937 124.689,99.533 L146.751,104.206 C138.524,123.652 121.884,133 101.504,133 C75.142,133 53.64,112.994 53.64,83.64 C53.64,54.286 75.142,34.093 101.878,34.093 C126.745,34.093 148.246,53.351 149.182,81.771 L149.182,90.184 Z" id="Fill-1"></path>
                      <path d="M387.843,83.64 C387.843,66.439 374.568,55.595 361.294,55.595 C346.336,55.595 335.118,66.439 335.118,83.64 C335.118,100.841 346.336,111.498 361.294,111.498 C374.568,111.498 387.843,100.841 387.843,83.64 Z M412.523,130.195 L387.843,130.195 L387.843,122.156 C380.364,129.074 370.081,133 356.993,133 C333.248,133 311.186,112.994 311.186,83.64 C311.186,54.286 333.248,34.093 356.993,34.093 C370.081,34.093 380.364,38.019 387.843,44.937 L387.843,0.937 L412.523,0.937 L412.523,130.195 Z" id="Fill-3"></path>
                      <path d="M630.3,92.427 C630.3,104.393 618.894,113.368 605.807,113.368 C596.271,113.368 589.915,108.88 589.915,101.962 C589.915,95.606 595.149,91.306 603.003,91.306 L630.3,91.306 L630.3,92.427 Z M614.407,37.117 L614.407,37.093 L580.299,37.093 L580.299,57.658 L614.407,57.658 C623.943,57.658 630.3,61.765 630.3,71.113 L630.3,72.61 L603.377,72.61 C579.818,72.61 566.356,84.576 566.356,102.524 C566.356,120.846 580.566,133 601.881,133 C614.595,133 623.943,128.7 630.3,122.53 L630.3,130.195 L653.858,130.195 L653.858,69.244 C653.858,47.082 638.243,37.617 614.407,37.117 Z" id="Fill-4"></path>
                      <path d="M484.378,92.427 C484.378,104.393 472.973,113.368 459.885,113.368 C450.349,113.368 443.992,108.88 443.992,101.962 C443.992,95.606 449.227,91.306 457.08,91.306 L484.378,91.306 L484.378,92.427 Z M468.485,37.117 L468.485,37.093 L434.377,37.093 L434.377,57.658 L468.485,57.658 C478.02,57.658 484.378,61.765 484.378,71.113 L484.378,72.61 L457.454,72.61 C433.895,72.61 420.434,84.576 420.434,102.524 C420.434,120.846 434.644,133 455.958,133 C468.672,133 478.02,128.7 484.378,122.53 L484.378,130.195 L507.935,130.195 L507.935,69.244 C507.935,47.082 492.321,37.617 468.485,37.117 Z" id="Fill-5"></path>
                      <path d="M279.3,92.427 C279.3,104.393 267.894,113.368 254.807,113.368 C245.271,113.368 238.914,108.88 238.914,101.962 C238.914,95.606 244.15,91.306 252.003,91.306 L279.3,91.306 L279.3,92.427 Z M263.408,37.117 L263.408,37.093 L229.299,37.093 L229.299,57.658 L263.408,57.658 C272.943,57.658 279.3,61.765 279.3,71.113 L279.3,72.61 L252.376,72.61 C228.818,72.61 215.356,84.576 215.356,102.524 C215.356,120.846 229.566,133 250.881,133 C263.595,133 272.943,128.7 279.3,122.53 L279.3,130.195 L302.858,130.195 L302.858,69.244 C302.858,47.082 287.244,37.617 263.408,37.117 Z" id="Fill-6"></path>
                      <path d="M216.11,37.026 C200.966,37.026 190.121,43.069 182.643,53.913 L182.643,36.899 L157.963,36.899 L157.963,130.197 L182.643,130.197 L182.643,100.095 C182.643,74.106 193.113,57.776 215.923,57.776 L217.044,57.776 L217.044,37.029 C216.741,37.027 216.431,37.026 216.11,37.026" id="Fill-7"></path>
                      <path d="M48.982,107.707 C45.229,109.115 41.291,110.002 38.328,110.002 C30.102,110.002 24.68,105.142 24.68,93.923 L24.68,57.09 L49.982,57.09 L49.982,36.898 L24.68,36.898 L24.68,14.007 L0,14.007 L0,95.793 C0,121.408 14.584,133 36.646,133 C44.438,133 51.879,131.338 61.481,126.199 C56.364,121.123 51.667,114.8 48.982,107.707" id="Fill-8"></path>
                      <path d="M558.509,109.788 C557.521,109.926 556.586,110.002 555.733,110.002 C547.507,110.002 542.085,105.142 542.085,93.923 L542.085,57.09 L568.068,57.09 L568.068,36.898 L542.085,36.898 L542.085,14.007 L517.404,14.007 L517.404,95.793 C517.404,121.408 531.988,133 554.051,133 C559.44,133 564.302,132.206 569.964,130.017 C562.645,124.774 559.799,116.281 558.509,109.788" id="Fill-9"></path>
                  </g>
                  <path d="M695.029,116.028 C695.029,124.853 688.257,131.624 678.817,131.624 C669.377,131.624 662.605,124.853 662.605,116.028 C662.605,107.615 669.377,100.227 678.817,100.227 C688.257,100.227 695.029,107.615 695.029,116.028" id="Fill-11" fill="#E46C42"></path>
              </g>
          </svg><span _ngcontent-nnp-c72="" class="td-navigation-drawer-title ng-tns-c72-69 ng-star-inserted">     Turnado</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <div style="text-align:left">
              <strong>{{$store.state.ApiUser_GivenName}}</strong>
            </div>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <div style="text-align:left">
              {{$store.state.ApiUser_EMail}}
            </div>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <div style="text-align:left">
              {{$store.state.MotherSupplier_Desc}}
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="notificationDrawer" app right temporary width="300">
      <v-list dense>
        <v-list-item v-for="notification in notifications" :key="notification.ApiEvent_id" @click="openDetailsDialog(notification)">
          <v-list-item-content>
            <v-list-item-title>{{ notification.EventTitle }}</v-list-item-title>
            <v-list-item-subtitle>Prioridad: {{ notification.Priority | prioridad}}</v-list-item-subtitle>
            <v-list-item-subtitle>Vigente hasta: {{ notification.EndDate_Dt | formatDate}}</v-list-item-subtitle>
        </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    

  </v-card>
<v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Login</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="user" label="Usuario*" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="password" label="Contraseña*" type="password" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-alert
            :type="type_message"
            border="left"
            close-text="Close Alert"
            :color="color_alert"
          >
            {{alert_message}}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" text @click="login">Login</v-btn>
          <v-btn color="primary" text @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
          <v-progress-linear v-if="process"
            indeterminate
            color="accent"
          ></v-progress-linear>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert" max-width="600px" color="error">
      <v-card>
        <v-card-title>
          <span>Alerta</span> 
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-list-item-title class="headline mb-1">{{this.alert_new_msj}}</v-list-item-title>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" text @click="alert = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="detailsDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ notificationDetails && notificationDetails.EventTitle }}</span>
        </v-card-title>
        <v-card-text>
          <div>{{ notificationDetails && notificationDetails.Description }}</div>
          
          <div>Inicio: {{ notificationDetails && notificationDetails.StartDate_Dt | formatDate }}</div>
          <div>Fin: {{ notificationDetails && notificationDetails.EndDate_Dt | formatDate }}</div>
          <div>Prioridad: {{ notificationDetails && notificationDetails.Priority | prioridad }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detailsDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    </v-sheet>
</v-app>
</template>
<script>
import axios from 'axios'
import Vue from 'vue'
import { EventBus } from '@/event-bus'

var logged = false
var items = []
// if (logged === true) {
//   items = [
//     { title: 'Home', icon: 'mdi-home', link: '/home' },
//     { title: 'Interfaces', icon: 'mdi-file-tree', link: '/interfaces' },
//     { title: 'Tickets', icon: 'mdi-receipt', link: '/tickets' },
//     { title: 'Tasks', icon: 'mdi-calendar-check', link: '/tasks' }
//   ]
// } else {
//   items = [
//     { title: 'Home', icon: 'mdi-home', link: "/" + this.$route.params.token + '/home' }
//   ]
// }

export default {
  name: 'App',
  data () {
    return {
      items,
      notificaciones2: [],
      totalNoLeidas: 0,
      drawer: false,
      type_message: 'info',
      alert_message: 'Ingrese usuario y contraseña',
      right: null,
      color: 'primary',
      color_alert: 'primary',
      colors: ['primary', 'accent', 'warning lighten-2', 'teal', 'orange'],
      logged,
      dialog: false,
      alert: false,
      user: '',
      password: '',
      mail: '',
      supplier: '',
      supplier_desc: '',
      displayName: '',
      alert_new_msj: '',
      user_data: { ApiUser_id: this.$store.state.ApiUser_id, ApiUser_GivenName: this.$store.state.ApiUser_GivenName, ApiUser_EMail: this.$store.state.ApiUser_EMail,  ApiUser_Supplier:  this.$store.state.ApiUser_Supplier, Supplier_Description: this.$store.state.MotherSupplier_Desc },
      //user_data: { ApiUser_id: '-', ApiUser_GivenName: '', ApiUser_EMail: '-',  ApiUser_Supplier: '-', Supplier_Description: '-' },
      process: false,
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      toolbar: this.$store.state.toolbar,
      token: this.$route.params.token,
      overlay: false,
      notificationDrawer: false,
      notifications: [],
      config: {
          headers: {
            // 'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
          }
        },
      notificationDetails: null,
      detailsDialog: false,
    }
  },
  mounted() {
    EventBus.$on('actualizarNotificaciones', this.cargarNotificaciones)

  },
  watch: {
  '$route'(to, from) {

      if (to.path.endsWith('/home') || to.name == 'Home') {
        this.getActiveEvents();
        this.cargarNotificaciones()
      }
    }
  },
  computed: {
    unreadNotificationsCount() {
      return this.notifications.filter(n => !n.read).length;
    },
    appBarColor() {
      // Agregado 2026-02-25 para modificar el color en el app-bar
      const host = window.location.hostname
      if (host.includes('localhost') || host.includes('10.22.178.89')) {
        return '#00387b' //Color azul de Carrefour
      }
      return 'primary'
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return new Intl.DateTimeFormat('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).format(new Date(value));
      }
      return '';
    },
    prioridad(value) {
      const priorities = {
        1: 'Alta',
        2: 'Media',
        3: 'Baja'
      };
      return priorities[value] || '';
    }
  },
  created () {
    Vue.set(this.toolbar, 'title', 'Home')
    if(this.token != undefined) {
      this.overlay = true
      this.check_token()
      //this.overlay = false
    }
    else {

    }
    
    // if (sessionStorage.getItem('access_token') || this.$route.params.token) {
    //   this.user_data.ApiUser_id = sessionStorage.getItem('ApiUser_id')
    //   this.user_data.ApiUser_EMail = sessionStorage.getItem('ApiUser_EMail')
    //   let config = {
    //     headers: {
    //       'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
    //     }
    //   }
    //   let data = {
    //     ApiUser_id: sessionStorage.getItem('ApiUser_id')
    //   }

    //   axios.post(this.api_tool_url + '/get_menu_user', data, config)
    //     .then(response => {
    //       if (this.logged === false) {
    //         this.logged = true
    //         response.data.ResultRows.forEach(menu => {
    //           this.items.push({ title: menu.ApiMenu_Title, icon: menu.ApiMenu_Icon, link: menu.ApiMenu_Link })
    //         })
    //         this.process = false
    //         this.dialog = false
    //       }
    //     })
    //     .catch(error => {
    //       if (error.response !== undefined) {
    //         //alert(error.response.data.message)
    //         alert(error.response.data.message)
    //       }
    //       else {
    //         //alert(error)
    //         alert(error.message)
    //       }
    //       this.process = false
    //       this.dialog = false
    //     })
    // } else {
    //   this.$router.push('home')
    // }
    // this.$vuetify.theme.dark = false
  },
  methods: {
    
    check_token: function() {
      var data
      data = {
        ApiKey_id: this.token,
        ApiKey_Status: 'Activa'
      }
      axios.post(this.api_tool_url + '/check_token', data)
        .then(response => {
          sessionStorage.setItem('ApiUser_id', response.data.ApiUser_id)
          sessionStorage.setItem('access_token', response.data.ApiKey_id)
          this.logged = true
          this.$store.commit('updateUser_detail',response.data)
          this.user_data.ApiUser_id = response.data.ApiUser_id
          //this.user_data.ApiUser_EMail = response.data.mail
          //this.user_data.ApiUser_GivenName = response.data.displayName
          //this.user_data.ApiUser_Supplier = response.data.ApiUser_Supplier
          //this.user_data.Supplier_Description = response.data.Supplier_Description
          if(response.data.BlackOutEnabled=='S')
          {
            this.get_menu()
          }
          else
          {
            this.alert = true
            this.alert_new_msj = "Fuera de Horario para Turnar"
            this.overlay = false
            this.$router.push("/" + this.token + '/home')
          }
        })
        .catch(error => {
          console.log(error)
          this.alert = true
          this.alert_new_msj = "Acceso no autorizado"
          this.overlay = false
          this.$router.push('/')
        })

    },
    get_menu: function() {
      let data = {
        ApiUser_id: this.user_data.ApiUser_id
      }

      let config = {
        headers: {
          "api-user": this.user_data.ApiUser_id
        }
      }

      console.log("Get Menu" + " " + this.user_data.ApiUser_id)
      axios.post(this.api_tool_url + '/get_usermenu', data, config)
        .then(response => {
          this.items.push({ title: 'Home', icon: 'mdi-home', link: "/" + this.token + '/home', imagen: 'mdi-home.jpg' })
          response.data.ResultRows.forEach(menu => {
              this.items.push({ title: menu.ApiMenu_Title, icon: menu.ApiMenu_Icon, link: "/" + this.token + menu.ApiMenu_Link, imagen: menu.ApiMenu_Image})
          })
          this.$store.commit('updateMenu',this.items)
          this.overlay = false
          this.$router.push("/" + this.token + '/home')
          this.getActiveEvents()
          this.cargarNotificaciones()
        })
        .catch(error => {
          console.log(error)
          this.overlay = false
          this.alert = true
        })
    },
    login: function () {
      this.overlay = true
      this.process = true
      this.type_message = 'warning'
      this.color_alert = 'accent'
      this.alert_message = 'Logueando, espere por favor...'
      let config = {
        headers: {
          'api-user': this.user
        }
      }
      let data = {
        usuario: this.user,
        password: this.password
      }
      axios.post(this.api_tool_url + '/login', data)
        .then(response => {
          if (this.logged === false) {
            this.logged = true
            this.token = response.data.ApiKey_id
            sessionStorage.setItem('ApiUser_id', response.data.ApiUser_id)
            sessionStorage.setItem('access_token', response.data.ApiKey_id)
            this.$store.commit('updateUser_detail',response.data)
            this.user_data.ApiUser_id = response.data.ApiUser_id
            
            if(response.data.BlackOutEnabled=='S')
            {
              this.get_menu()
              //this.check_token(this.token)
              this.type_message = 'success'
              this.alert_message = 'Logueo correcto.'
              this.process = false
              this.dialog = false
              this.type_message = 'info'
              this.alert_message = 'Ingrese usuario y contraseña'
              this.color_alert = 'primary'
              this.user = ''
              this.password = ''
              
            }
            else{
              this.type_message = 'success'
              this.alert_message = 'Logueo correcto.'
              this.process = false
              this.dialog = false
              this.overlay = false
              this.type_message = 'info'
              this.alert_message = 'Ingrese usuario y contraseña'
              this.color_alert = 'primary'
              this.user = ''
              this.password = ''
              this.alert = true
              this.alert_new_msj = "Fuera de Horario para Turnar"
              this.$router.push("/" + this.token + '/home')
            }
          }
        })
        .catch(error => {
          console.log(error.response.data)
          if (error.response !== undefined) {
            //alert(error.response.data.message)
            //alert(error.response.data.message)
            this.type_message = 'error'
            this.color_alert = 'error'
            this.alert_message = error.response.data
          }
          else {
            //alert(error)
            this.type_message = 'error'
            this.color_alert = 'error'
            this.alert_message = error.message
          }
          this.process = false
          this.overlay = false
          //this.dialog = false
        })
    },
    logout: function () {
      if (this.logged === true) {
        this.logged = false
        let menuLength = this.items.length
        for (var i = 0; i < menuLength; i++) {
          this.items.pop()
        }
        let data = {'ApiUser_id':'-', 'displayName': '-', 'mail':  '-', 'ApiKey_id': '-', 'ApiUser_Supplier': '-', 'MotherSupplier_Desc': '-','ApiUserType_id': '-'}
        this.$store.commit('updateUser_detail',data)
        this.$router.push('/')
        if (this.$router.history.current.path !== '/home') {
          this.$router.push('home')
        }
      }
    },
    async cargarNotificaciones() {
      try {
        let data = {
          RepOrderUsers_id: this.user_data.ApiUser_id,
          RepOrderNotification_Ind: 'N'
        }
        let config = {
          headers: {
            "api-user": this.user_data.ApiUser_id
          }
        }
        axios.post(this.api_tool_url + '/get_RepOrderNotification', data, config)
        .then(response => {
          this.notificaciones2 = response.data.ResultRows
          this.totalNoLeidas = response.data.ResultRows.length
        })
        .catch(error => {
          this.notificaciones2 = []
          alert(error.response.data.message)
        })

      } catch (error) {
        console.error('Error al cargar notificaciones:', error)
      }
    },
    async marcarComoLeida(id) {
      try {
        let data = {
          RepOrderUsers_id: this.user_data.ApiUser_id,
          RepOrderNotification_Ind: 'N',
          RepOrderNotification_id: id
        }
        let config = {
          headers: {
            "api-user": this.user_data.ApiUser_id
          }
        }
        axios.post(this.api_tool_url + '/upd_RepOrderNotification', data, config)
        .then(response => {
          this.notificaciones2 = response.data.ResultRows
          this.totalNoLeidas = response.data.ResultRows.length
        })
        .catch(error => {
          this.notificaciones2 = []
          alert(error.response.data.message)
        })

      } catch (error) {
        console.error('Error al cargar notificaciones:', error)
      }
    },
    openDetailsDialog(notification) {
      this.notificationDetails = notification;
      this.detailsDialog = true;
      notification.read = true;
    },
    getActiveEvents: function() {
      let config = {
        headers: {
          "api-user": this.user_data.ApiUser_id
        }
      }
        this.loading = true;
        axios.get(this.api_tool_url + '/getActiveEvents', config) 
        .then(response => {
          this.notifications = response.data.map(notification => ({
        ...notification,
        read: false
      }));
      this.loading = false;
       })
      .catch(error => {
        console.error('Error al cargar:', error);
        this.notifications = [];
      })
    
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue